<template>
  <div>
    <TopHeader headerTitle="我的礼包" :isShowMenuIcon="false" />
    <Scroll ref="scroll" :class="$style.wrapper" :pullup="true" @bsPullingUp="bsPullingUp">
      <div :class="$style.box">
        <div v-for="item of myGiftList" :key="item.id" :class="$style['gift-item']">
          <img
            :src="item.icon"
            @click="handleLinkTo('giftCenter.details', { giftId: item.gift_set_id })"
          />
          <section
            :class="$style.info"
            @click="handleLinkTo('giftCenter.details', { giftId: item.gift_set_id })"
          >
            <p>
              {{ item.title }}
              <img v-if="item.type == 1" :src="vipIcon" width="21px" />
              <img v-else :src="commonIcon" width="21px" />
            </p>
            <p v-if="item.type === 1">
              <span>{{ '领取时间:' }}</span>
              {{ formatDate(item.used_time) }}
            </p>
            <p v-if="item.type === 2">
              <span>{{ item.state ? '' : '失效时间:' }}</span>
              {{ item.state || formatDate(item.failure_time) }}
            </p>
            <div :style="{ opacity: item.type === 2 ? 1 : 0 }">
              <span>礼包码：</span>
              <input :value="item.code" readonly="readonly" />
            </div>
          </section>
          <div v-if="item.type === 2 && !item.state" :class="$style.btn">
            <button class="copyBtn" :data-clipboard-text="item.code">复制</button>
          </div>
        </div>
        <div ref="tips" :class="$style.nomore">
          <p v-if="noMore">—— 没有更多礼包了 ——</p>
        </div>
      </div>
    </Scroll>
  </div>
</template>

<script>
import TopHeader from '_c/TopHeader';
import Scroll from '_c/Scroll';
import { Toast } from "vant";
import { getMyGiftList } from '@/api/giftCenter';
import { CDN_URL } from "@/config/index.js";
import Clipboard from "clipboard";
import dayjs from 'dayjs'
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  components: {
    TopHeader,
    Toast,
    Scroll
  },
  data() {
    return {
      commonIcon: `${CDN_URL}/gift_center/all.png`,
      vipIcon: `${CDN_URL}/gift_center/VIP.png`,
      title: '我的礼包',
      myGiftList: [],
      currentPage: 1,
      total: 0, // 列表总数
      noMore: false,
    };
  },
  created() {
    this.getMyGiftList()
  },
  mounted() {
    this.copyInit();
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING'
    }),
    async getMyGiftList() {
      this.CHANGE_SHOW_LOADING(true)
      const r = await getMyGiftList({ page: this.currentPage, limit: 10 })
      this.total = r.data.total;
      if (this.currentPage == 1) {
        this.myGiftList = [...[]]
      }
      this.myGiftList = this.myGiftList.concat([...r.data.data])
      this.CHANGE_SHOW_LOADING(false)
      setTimeout(() => {
        this.$refs.scroll && this.$refs.scroll.refresh();
      }, 10);
    },
    copyInit() {
      this.copy = new Clipboard(".copyBtn");
      this.copy.on("success", e => {
        Toast("复制成功");
        e.clearSelection();
      });
    },
    // 路由跳转
    handleLinkTo(name, query) {
      this.$router.push({ name, query })
    },
    formatDate(date) {
      return dayjs(date).format('YYYY年MM月D日')
    },
    // 下拉加载
    bsPullingUp() {
      if (this.myGiftList.length == this.total) {
        this.noMore = true
        return
      }
      this.currentPage++
      setTimeout(() => {
        this.getMyGiftList()
      }, 10);
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
@import '~@/styles/variable.scss';
.wrapper {
  height: calc(100vh - 94px);
  background-color: #efefef;
}
.box {
  padding-top: 3px;
  padding-bottom: 10px;
  width: 100vw;
  height: auto;
  .gift-item {
    margin: auto;
    margin-top: 7px;
    padding: 12px 17px 12px 17px;
    width: 361px;
    height: 76px !important;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    display: flex;
    align-items: center;
    > img {
      margin-top: -6px;
      width: 45px;
      margin-right: 7px;
      border-radius: 12px;
    }
    .info {
      width: 218px;
      p:first-of-type {
        font-size: 11px;
        line-height: 12.5px;
      }
      p:last-of-type {
        @include ellipsis(1);
        margin-top: 4px;
        font-size: 10px;
        color: #9f9f9f;
      }
      div {
        padding: 0px 3.5px 0px 3.5px;
        margin-top: 6px;
        margin-left: -4px;
        width: 149px;
        height: 18px;
        line-height: 18px;
        font-size: 10px;
        border-radius: 10px;
        background-color: #f3f3f3;
        > span {
          display: inline-block;
          margin-right: 2px;
          height: 18px;
          line-height: 18px;
          color: #ff7e30;
        }
        > input {
          @include clearBtnDefaultStyle;
          @include ellipsis(1);
          width: 90px;
          height: 18px;
          line-height: 18px;
          display: inline-block;
          color: #9f9f9f;
        }
      }
    }
    .btn {
      button {
        @include clearBtnDefaultStyle;
        margin-left: 10px;
        width: $buttonWidth;
        height: $buttonHeight;
        color: #fff;
        font-size: 10px;
        background-color: $buttonColor;
        border-radius: 15px;
      }
    }
  }
  .nomore {
    height: 50px;
    line-height: 50px;
    font-size: 12px;
    text-align: center;
    color: rgba(159, 159, 159, 1);
  }
}
</style>
